
import * as api from "../../api"; 
import { appTokenString } from "../../constants/appInfo";

  
export const clientAppUserSignUp = (post) => async (dispatch)=>{
    try {  const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
    
    // console.log(dataObject); 
        const {data } = await api.clientAppUserSignUp(dataObject);

        // console.log(data);
           dispatch({
            type: "SIGNUP",
            /* In my Case , I am getting data in the form of JSON encode String so , I am covverting it into 
            Object Before storing it into Redux store using () */ 
            payload:(data?.userData)
          }); 
         /* return data in the form of a Promise to the function where it was called  */
         let MyToken =(data?.user)?.token;
         localStorage.setItem("profile",MyToken)
      
        return (data) 
     } catch (error) {
        console.error(error);
    }
}

  
export const clientAppUserLogin = (post) => async (dispatch)=>{
    try {  const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
    
    // console.log(dataObject);
        const {data } = await api.clientAppUserLogin(dataObject);

        // console.log(data);
           dispatch({
            type: "LOGIN",
            
            /* In my Case , I am getting data in the form of JSON encode String so , I am covverting it into 
            Object Before storing it into Redux store using () */ 
            payload:(data?.userData)
          }); 
         
         /* return data in the form of a Promise to the function where it was called  */
         let MyToken =(data?.user)?.token;
         localStorage.setItem("profile",MyToken)
      
        return (data) 
     } catch (error) {
        console.error(error);
    }
}

  
export const clientAppUserOTPLogin = (post) => async (dispatch)=>{
    try {  const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
    
    // console.log(post);
    // console.log(dataObject);
        const {data } = await api.clientAppUserOTPLogin(dataObject);

        dispatch({
            type: "CurrentUserEmail",
            /* In my Case , I am getting data in the form of JSON encode String so , I am covverting it into 
            Object Before storing it into Redux store using () */ 
            payload:post
          }); 
         /* return data in the form of a Promise to the function where it was called  */
         let MyToken =(data?.user)?.token;
         localStorage.setItem("profile",MyToken)
      
        return (data) 
     } catch (error) {
        console.error(error);
    }
}




export const clientAppUserVerifyOTP = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
        const {data } = await api.clientAppUserVerifyOTP(dataObject);
       
       if((data)){
        dispatch({
            type: "UPDATE_USER_DATA",
            
            /* In my Case , I am getting data in the form of JSON encode String so , I am covverting it into 
            Object Before storing it into Redux store using () */ 
            payload:(data)
          }); 
       }
         /* return data in the form of a Promise to the function where it was called  */
         
         let MyToken =(data)?.token;
         localStorage.setItem("profile",MyToken)
      
        return (data) ;
    
        } catch (error) {
        console.log(error);
    }
}



export const clientAppUserChangePassword = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.clientAppUserChangePassword(dataObject);
        dispatch({
            type: "CurrentUserEmail",
            /* In my Case , I am getting data in the form of JSON encode String so , I am covverting it into 
            Object Before storing it into Redux store using () */ 
            payload:post
          }); 
         /* return data in the form of a Promise to the function where it was called  */
     
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}





